





import { Component, Vue, Prop } from 'vue-property-decorator';
import { ORIGIN_FORMAT } from '@/utils/index';

import { Input as ElInput } from 'element-ui';
@Component({
    name: 'NumberInput',
})
export default class NumberInput extends Vue{
    @Prop({ type: Number, required: true }) value!: number;
    @Prop({ type: String, default: '' }) unit!: string;
    @Prop({ type: String, default: '' }) size!: string;
    private isFocus: boolean = false;
    get model() {
        if (this.isFocus) {
            return this.value.toString();
        }
        return ORIGIN_FORMAT.NumberFormatOrigin(this.value) + ' ' + this.unit;
    }
    set model(v: string) {
        let newValue = Number.parseFloat(v.replace(/[^\d\.]/g, ""))
        if (Number.isNaN(newValue)) {
            newValue = 0;
        }
        if (newValue > 100000000000000000000) {
            newValue = 100000000000000000000;
        }
        this.$emit('input', newValue);
    }
    private onFocus(e: Event) {
        this.isFocus=true;
        const input = e.target as HTMLInputElement
        this.$nextTick( () => {
            const length = this.value.toString().length;
            input.setSelectionRange(0, length);
        })
    }
}
